export default __webpack_public_path__ + "dd542b99810a9ee727938bf88dbaedd0.png";